import React from 'react';
import { authRoles } from '../../auth/authRoles';

//navigations.jsで使用
const dashboardRoutes = [
	{
		path: '/develop', //開発用
		component: React.lazy(() => import('./Develop')),
		auth: authRoles.sa,
	},
	{
		path: '/sample',
		component: React.lazy(() => import('./Develop')),
		auth: authRoles.sa,
	},
	{
		path: '/dashboard',
		component: React.lazy(() => import('./Analytics2')),
		auth: authRoles.admin,
	},
	{
		path: '/alternative', //URL
		component: React.lazy(() => import('./Analytics')), //遅延ロード用のコンポーネントをimportする
		auth: authRoles.sa, //アクセス権限
	},
	{
		path: '/inventory-management',
		component: React.lazy(() => import('./InventoryManagement')),
		auth: authRoles.admin,
	},
];

export default dashboardRoutes;
